import { ControlsService } from "./generated";
import { withApiData } from "./openapiClient";

const buildListParams = (params = {}) => ({
  limit: params.limit,
  offset: params.offset,
  q: params.q ?? undefined,
  sort: params.sort,
  category: params.category ?? undefined,
});

export async function getControls(params = {}) {
  return withApiData(
    ControlsService.listControlsControlsGet({
      ...buildListParams(params),
    })
  );
}

export async function getControl(id) {
  const controlId = Number(id);
  return withApiData(
    ControlsService.getControlControlsControlIdGet({
      controlId,
    })
  );
}

export async function createControl(data) {
  return withApiData(
    ControlsService.createControlControlsPost({
      requestBody: {
        ...data,
      },
    })
  );
}

export async function updateControl(id, data) {
  const controlId = Number(id);
  return withApiData(
    ControlsService.updateControlControlsControlIdPut({
      controlId,
      requestBody: {
        ...data,
      },
    })
  );
}

export async function deleteControl(id) {
  const controlId = Number(id);
  return withApiData(
    ControlsService.deleteControlControlsControlIdDelete({
      controlId,
    })
  );
}
